/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {ReportTranslationApiService, ReportTranslationModel} from './report-translation-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-report-translation-list-page',
  template: `
    <ng-template #rowTemplate let-item>
      <td><a [uiSref]="itemStateName" [uiParams]="{id: item.id}">{{ item.name }}</a></td>
      <td>{{ item.description }}</td>
      <td>{{ ('locale.' + item.locale) | ogTranslate }}</td>
      <td>{{ ('language.' + item.defaultTranslation) | ogTranslate }}</td>
    </ng-template>
    <adn-signal-admin-resource-list
      [state]="list"
      [columns]="columns"
      emptyMessage="No report translations are available."
      loadErrorMessage="Report translations could not be loaded."
      [enableSearch]="true"
      [rowTemplate]="rowTemplate">
    </adn-signal-admin-resource-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTranslationListPageComponent implements OnInit {
  readonly itemStateName = 'app.rep.report-translations.report-translation';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'locale'},
    {param: 'defaultTranslation'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<ReportTranslationModel>(
    inject(ReportTranslationApiService),
    {listId: 'fullReportTranslationList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
